import React from "react";
import { AlertTriangle, DollarSign, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TID } from "@/lib/testIds";

export default function FeeReminderBanner({ owed, threshold, autopayEnabled, onPay, onDismiss }) {
  return (
    <div
      data-testid={TID.feeReminderBanner}
      className="w-full border-b border-amber-500/40 bg-amber-500/10 text-amber-100"
    >
      <div className="max-w-[1600px] mx-auto px-4 lg:px-8 py-2.5 flex items-center gap-3 text-xs">
        <AlertTriangle className="w-4 h-4 shrink-0 text-amber-300" />
        <div className="truncate">
          <span className="font-semibold">Fees due:</span> you have <b className="font-mono">${owed.toFixed(2)}</b> owed
          {autopayEnabled ? " — auto-pay is on, we'll settle it automatically at the next scan." :
            ` in platform fees. Settle now to keep your account tidy (threshold $${threshold}).`}
        </div>
        {!autopayEnabled && (
          <Button onClick={onPay} className="ml-auto shrink-0 h-8 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-semibold text-xs px-3">
            <DollarSign className="w-3 h-3 mr-1" /> Pay now
          </Button>
        )}
        <button
          onClick={onDismiss}
          className="shrink-0 text-amber-200 hover:text-white p-1 rounded"
          title="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
